/** @format */

import React, { useState } from "react";
import { ITwoFALoginFormProps } from "./TwoFALoginForm.types";
import TwoFALoginFormView from "./TwoFALoginForm.view";

const TwoFALoginFormContainer: React.FC<ITwoFALoginFormProps> = (props) => {
	const [otp, setOtp] = useState([]);

	const checkOtpIsNotEmpty = (): boolean =>
		otp !== undefined;

	const checkFormFieldsAreValid = (): boolean =>
		checkOtpIsNotEmpty() && otp.every((val) => val !== '') && otp.length === 6;

	const calculateDisableLogIn = (): boolean => !checkFormFieldsAreValid();

	function onChangeOtp(value) {
		setOtp(value);
		console.log(otp);
	}

	const onClickLogIn = () => {
		if (otp !== undefined) {
			props.onClickLogIn({ otp });
		} else {
			console.log("problem");
		}
	};

	return (
		<TwoFALoginFormView
			disableLogIn={calculateDisableLogIn()}
			otp={otp}
			onChangeOtp={onChangeOtp}
			onClickLogIn={onClickLogIn}
		/>
	);
};

export default TwoFALoginFormContainer;
